import { makePermissionMetadata } from './permission-metadata';
export function makePermissionSystem(systemDef) {
  const {
    permissionsMetadata,
    superPermDeps
  } = makePermissionMetadata(systemDef.permissionTypes, systemDef.actionTypes, systemDef.permissionsMetadata, systemDef.superPerms);
  return {
    permissionTypes: systemDef.permissionTypes,
    actionTypes: systemDef.actionTypes,
    superPerms: systemDef.superPerms,
    superPermDeps,
    permissionsMetadata
  };
}